export const DECK_SIZE = 8;

export function isValidDeckComposition(deck: readonly string[]): boolean {
  return deck.length === DECK_SIZE && new Set(deck).size === deck.length;
}
